// extracted by mini-css-extract-plugin
module.exports = {"page":"docs_page__3gAMG","header":"docs_header__3In9h","list":"docs_list__AC2iR","title":"docs_title__dzSwj"};